import React from 'react'
import { StyleSheet, View } from '@react-pdf/renderer'
import ContentBox from "../../../ContentBox"
import { DataField } from "../../../Label"
import ProcessRow from "./ProcessRow"
import ErrorDataText from "../../ErrorDataText"

const styles = StyleSheet.create({
  content: {
    marginTop: 8,
  },
})
const ProcessDataVariableReport = (props) => {
  const { processData } = props
  try {

    return (
      <View>
        <DataField
          label='Possui processos de qualquer natureza?'
          value={processData?.has_any_process ? 'Sim' : 'Não'}
        />

        {
          processData?.has_any_process && (
            <ContentBox style={styles.content}>
              <DataField label='Resumo de processos:' />
              <View style={styles.content}>
                <DataField
                  label='Possui processos não criminais?'
                  value={processData?.has_non_criminal_process ? 'Sim' : 'Não'}
                />

                <DataField
                  label='Possui processos movidos por entidade regulatória?'
                  value={processData?.has_process_from_regulatory_entity ? 'Sim' : 'Não'}
                />

                <DataField
                  label='Possui penalidades financeiras?'
                  value={processData?.has_financial_penalty ? 'Sim' : 'Não'}
                />

                <DataField
                  label='Possui processos com palavras-chave de risco?'
                  value={processData?.has_process_with_risk_keywords ? 'Sim' : 'Não'}
                />

                <DataField
                  label='Possui processos administrativos?'
                  value={processData?.has_administrative_process ? 'Sim' : 'Não'}
                />

                <DataField
                  label='Possui processos judiciais?'
                  value={processData?.has_judicial_process ? 'Sim' : 'Não'}
                />
              </View>
            </ContentBox>
          )
        }
        {processData ? (
          processData?.processes?.length > 0 && (
            <ContentBox>
              <DataField label='Processos:' value='' />
              <View style={styles.content}>
                {processData?.processes?.map((process) => {
                  return (
                    <ProcessRow
                      key={`process:${process.uuid}`}
                      processData={process}
                    />
                  )
                })}
              </View>
            </ContentBox>
          )
        ) : (
          <ErrorDataText contextName='ProcessDataVariableReport' />
        )}
      </View>
    )
  } catch (err) {
    return (
      <ErrorDataText
        exception={err}
        contextName="ProcessDataVariableReport"
        extraData={processData}
      />
    )
  }
}

export default ProcessDataVariableReport
